import Loading from '../../../Loading/Loading';
import { AnswerSelectPresentationProps } from '../config';
import { Chip } from '../../../presenters/Chip/Chip';
import { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _PresentChips: FC<AnswerSelectPresentationProps> = ({ answers, onPress, loading }) => {
  const { treeNav } = useStores();

  if (loading) {
    return <Loading />;
  }

  return (
    <View style={styles.chips}>
      {answers?.map(answer => (
        <Chip
          key={answer._id}
          label={answer.wording || ''}
          onPress={() => onPress(answer)}
          selected={treeNav.choices.pending?.answers?.some(a => a.id === answer._id)}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  chips: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    gap: 16,
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
});

export const PresentChips = observer(_PresentChips);
